import { render, staticRenderFns } from "./CollapseBootstrapVue.vue?vue&type=template&id=8671a4a8&"
import script from "./CollapseBootstrapVue.vue?vue&type=script&lang=js&"
export * from "./CollapseBootstrapVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports